import { render, staticRenderFns } from "./PerformanceTrendList.vue?vue&type=template&id=fb9c3bd2&scoped=true"
import script from "./PerformanceTrendList.vue?vue&type=script&lang=js"
export * from "./PerformanceTrendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9c3bd2",
  null
  
)

export default component.exports